'use client';

import { useEffect, useState } from 'react';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

export default function PageTransition({ children, className = '' }: PageTransitionProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(false);
    const id = requestAnimationFrame(() => setIsVisible(true));

    return () => {
      cancelAnimationFrame(id);
    };
  }, []);

  return (
    <div data-component-id="src/components/ui/PageTransition.tsx:23:4" data-component-path="src/components/ui/PageTransition.tsx" data-component-line="23" data-component-end-line="25" data-component-file="PageTransition.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`page-fade ${className}`} data-page-state={isVisible ? 'in' : 'out'}>
      {children}
    </div>
  );
}
